'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _xml = require('@xmpp/xml');
var _xml2 = _interopRequireDefault(_xml);
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _safeSender = require('../infra/safeSender');
var _safeSender2 = _interopRequireDefault(_safeSender);
var _iqBuilder = require('../iq/iqBuilder');
var _iqBuilder2 = _interopRequireDefault(_iqBuilder);
var _chatParser = require('./chatParser');
var _chatParser2 = _interopRequireDefault(_chatParser);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var NS = {
  MUC_ENTER_ROOM: 'urn:xmpp:enter_room',
  MUC_CREATE_ROOM: 'urn:xmpp:create_room',
  MUC_RETRIEVE: 'urn:xmpp:muc_retrieve',
  RSM: 'http://jabber.org/protocol/rsm',
  MUC_DISABLE_ROOM: 'urn:xmpp:disable_room',
  MUC_MARK_READ: 'urn:xmpp:mark_as_read'
};
var ChatManager = function (_Plugin) {
  _inherits(ChatManager, _Plugin);
  function ChatManager() {
    _classCallCheck(this, ChatManager);
    return _possibleConstructorReturn(this, (ChatManager.__proto__ || Object.getPrototypeOf(ChatManager)).apply(this, arguments));
  }
  _createClass(ChatManager, [{
    key: 'fetch',
    value: function fetch(_ref) {
      var before = _ref.before,
        after = _ref.after,
        _ref$max = _ref.max,
        max = _ref$max === undefined ? null : _ref$max,
        roomname = _ref.roomname;
      var iq = this.iqBuilder.get(NS.MUC_RETRIEVE, (0, _xml2.default)('set', {
        xmlns: NS.RSM
      }, max && (0, _xml2.default)('max', null, max), (0, _xml2.default)('fetch_inactive_ads', null), after && (0, _xml2.default)('after', null, after), before && (0, _xml2.default)('before', null, before), roomname && (0, _xml2.default)('roomname', null, roomname)));
      return this.send(iq);
    }
  }, {
    key: 'createRoom',
    value: function createRoom(listId, appVersion) {
      var iq = (0, _xml2.default)('iq', {
        type: 'set'
      }, (0, _xml2.default)('query', {
        xmlns: NS.MUC_CREATE_ROOM
      }, (0, _xml2.default)('list_id', null, listId), (0, _xml2.default)('appVersion', null, appVersion)));
      return this.send(iq);
    }
  }, {
    key: 'joinRoom',
    value: function joinRoom(roomname, appVersion, shouldLoadRoom) {
      var iq = (0, _xml2.default)('iq', {
        type: 'set'
      }, (0, _xml2.default)('query', {
        xmlns: NS.MUC_ENTER_ROOM
      }, (0, _xml2.default)('roomname', null, roomname), (0, _xml2.default)('appVersion', null, appVersion), shouldLoadRoom && (0, _xml2.default)('load_room', null)));
      return this.send(iq);
    }
  }, {
    key: 'disableRoom',
    value: function disableRoom(roomname) {
      var iq = this.iqBuilder.set(NS.MUC_DISABLE_ROOM, (0, _xml2.default)('roomname', null, roomname));
      return this.send(iq);
    }
  }, {
    key: 'lastSeen',
    value: function lastSeen(roomname, unreadMessages) {
      var iq = this.iqBuilder.set(NS.MUC_MARK_READ, (0, _xml2.default)('room', null, (0, _xml2.default)('roomname', null, roomname), (0, _xml2.default)('messages', null, unreadMessages.map(function (msg) {
        return (0, _xml2.default)('message', null, msg.originalTimestamp);
      }))));
      return this.send(iq);
    }
  }, {
    key: 'send',
    value: function send(iq) {
      var _this2 = this;
      return this.safeSender.send(iq).then(this.chatParser.extract).catch(function (ex) {
        var _chatParser$extract = _this2.chatParser.extract(ex.stanza),
          _chatParser$extract2 = _slicedToArray(_chatParser$extract, 1),
          chat = _chatParser$extract2[0];
        ex.chat = chat;
        throw ex;
      });
    }
  }]);
  return ChatManager;
}(_plugin2.default);
ChatManager.pluginName = 'chatManager';
ChatManager.deps = [_safeSender2.default, _iqBuilder2.default, _chatParser2.default];
exports.default = ChatManager;